import { render } from "./ProducerComplaintModal.vue?vue&type=template&id=7048112c"
import script from "./ProducerComplaintModal.vue?vue&type=script&lang=js"
export * from "./ProducerComplaintModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__